import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "../functions/AuthState";
import { useEffect, useState } from "react";

const ProtectedRoute = () => {
  const { isAuthenticated, loading } = useAuthStore();
  const [isLoading, setIsLoading] = useState(true);

  // Manejar el estado de carga para evitar cualquier renderizado antes de verificar la autenticación
  useEffect(() => {
    if (!loading) {
      setIsLoading(false);
    }
  }, [loading]);

  if (isLoading) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <div className="space-y-4">
          <div className="h-12 w-64 bg-gray-200 animate-pulse rounded-md"></div>
          <div className="h-8 w-48 bg-gray-200 animate-pulse rounded-md"></div>
          <div className="h-8 w-64 bg-gray-200 animate-pulse rounded-md"></div>
        </div>
      </div>
    );
  }

  return isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
